import { get } from 'lodash';
import Types from '../../constants/ActionTypes';
import Languages from '../../constants/Languages';

const initialState = {
  user: {
    birth_date: null,
    first_name: '',
    last_name: '',
    zip_code: null,
    dietary_preferences: [],
    assistance_programs: [],
  },
  flow: '',
  emailOrPhoneResult: {},
  emailOrPhoneError: null,
  emailOrPhone: null,
  language: {
    name: 'en',
    label: 'English',
    full: 'english',
  },
  showOtpSentAlert: false,
  sessionId: null,
  token: null,
  showOtp: false,
  phone: null,
  error: false,
  otp: {}, // timeout, opt_requests_left
  enterPhone: {
    skipped: false,
    results: {},
    error: null,
  },
  enterEmail: {
    skipped: false,
    results: {},
    error: null,
  },
  unsubscribeEmail: {
    email: '',
    subscribed: true,
  },
  showDeleteAccount: false,
  tefapConfig: {},
};

const languages = {};
Languages.languages.forEach((lang) => {
  languages[lang.full] = lang;
});

export default function registration(state = initialState, action = {}) {
  switch (action.type) {
    case Types.SELECT_LANGUAGE_NEXT:
      return Object.assign({}, initialState, {
        language: action.data,
      });

    case Types.REGISTRATION_FLOW:
      state.flow = action.data;
      return Object.assign({}, state);

    case Types.CLOSE_OTP_SENT_ALERT:
      state.showOtpSentAlert = false;
      return Object.assign({}, state);

    case Types.NEW_USER:
      state.user = Object.assign({}, state.user, action.data.user);
      state.error = null;
      return Object.assign({}, state);

    case Types.SEND_OTP:
      state.phone = action.data;
      state.showOtpSentAlert = true;
      return Object.assign({}, state);

    case Types.SHOW_OTP:
      state.showOtp = true;
      state.otp = action.data;
      return Object.assign({}, state);

    case Types.CANCEL_OTP_CODE:
      state.showOtp = false;
      return Object.assign({}, state);

    case Types.STORE_SESSION_ID:
      state.sessionId = action.data;
      return Object.assign({}, state);

    case Types.CURRENT_USER:
    case Types.EXISTING_USER:
      state.user = Object.assign({}, action.data);
      state.error = null;
      return Object.assign({}, state);

    case Types.ONBOARDING_COMPLETED:
      state.user = Object.assign({}, action.data);
      return Object.assign({}, state);

    case Types.UPDATE_USER:
      state.user = Object.assign({}, action.data);
      state.language = languages[state.user.language];
      return Object.assign({}, state);

    case Types.EXPO_PUSH_TOKEN:
      state.user = Object.assign({}, state.user, {
        expo_push_token: action.data.token,
        device_expo_push_token: action.data.token,
      });
      return Object.assign({}, state);

    case Types.LOGIN:
      state.user = Object.assign({}, action.data.user);
      state.language = languages[action.data?.user?.language || 'english'];
      return Object.assign({}, state);

    case Types.LOGOUT:
      return Object.assign({}, initialState);

    case Types.EMAIL_OR_PHONE: {
      state.emailOrPhoneResult = action.data;
      return Object.assign({}, state);
    }

    case Types.EMAIL_OR_PHONE_ERROR: {
      state.emailOrPhoneError = action.data;
      return Object.assign({}, state);
    }

    case Types.CLEAR_EMAIL_OR_PHONE_ERROR: {
      state.emailOrPhoneError = null;
      return Object.assign({}, state);
    }

    case Types.ACCEPT_TERMS_PRIVACY: {
      state.user = Object.assign({}, action.data);
      return Object.assign({}, state);
    }

    case Types.ENTER_EMAIL: {
      state.enterEmail = action.data;
      return Object.assign({}, state);
    }

    case Types.CLEAR_ENTER_EMAIL: {
      state.enterEmail = initialState.enterEmail;
      return Object.assign({}, state);
    }

    case Types.CLEAR_EMAIL_ERROR:
      state.enterEmail.error = null;
      return Object.assign({}, state);

    case Types.EMAIL_VERIFIED:
      state.enterEmail = {
        results: action.data,
        error: null,
      };
      return Object.assign({}, state);

    case Types.SKIP_EMAIL:
      state.enterEmail = Object.assign({}, state.enterEmail, { skipped: true });
      return Object.assign({}, state);

    case Types.ENTER_PHONE:
      state.enterPhone = action.data.response;
      state.phone = action.data.phone;
      if (get(action.data.response, 'results.sms_enabled')) {
        state.showOtpSentAlert = true;
      }
      return Object.assign({}, state);

    case Types.CLEAR_PHONE_ERROR:
      state.enterPhone.error = null;
      return Object.assign({}, state);

    case Types.UNSUBSCRIBE_EMAIL:
      state.unsubscribeEmail = action.data;
      return Object.assign({}, state);

    case Types.OPEN_DELETE_ACCOUNT: {
      state.showDeleteAccount = true;
      return Object.assign({}, state);
    }

    case Types.CLOSE_DELETE_ACCOUNT: {
      state.showDeleteAccount = false;
      return Object.assign({}, state);
    }

    case Types.ERROR:
      state.error = action.data;
      return Object.assign({}, state);

    case Types.LOAD_TEFAP_CONFIG:
      state.tefapConfig = action.data;
      return Object.assign({}, state);

    default:
      return Object.assign({}, state);
  }
}
